var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.95029 14.8662C2.60156 13.2361 3.48459 11.7018 4.64954 10.3704C6.64294 8.09226 9.5014 6.36132 13.5717 5.77984L14.3444 5.66945V4.88889V2.17279L20.7272 8.55556L14.3444 14.9383V12.1V11.2H13.4444C8.6801 11.2 4.91119 12.3576 1.95029 14.8662Z",
    stroke: "#626262",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.2221588e01d56aedbbb11301a171286b.svg";
export { ForwardRef as ReactComponent };